export const NEWS_API = `v1/latest-news`;
